export enum CatalogDetailsType {
	Public = 1,
	Preview = 2,
	WatchlistDefault = 3,
	WatchlistUserdefined = 4
}